import React, { Component } from 'react';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { AccountHeadMasterPopup } from './AccountHeadMasterTable';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { CommonValidationMessages } from '../../../utils/Messages';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class AccountHeadMaster extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            accountHeadObject: {
                idAccountHead: 0,
                updateStatus: 0,
                accHeadNo: "",
                accHeadName: "",
                accHeadDesc: "",
                remarks: "",
                openingBalance: "",
                openingDate: "",
                e_Date: "",
                accGrpList: [],
                selectedAccGrp: {},
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                accHeadName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "account head name"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getMasterAccountHeadSelectbyID(event.data.idAccountHead);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState })
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.accountHeadObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.accountHeadObject;
        details[name] = value;
        this.setState({ accountHeadObject: details });
    }

    setFilterParameters = (selected, drpIdentity) => {
        let details = this.state.accountHeadObject;
        details[drpIdentity] = selected;
        this.setState({ accountHeadObject: details });
    };

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let accountObject = this.state.accountHeadObject;
        accountObject.idAccountHead = 0;
        accountObject.updateStatus = 0;
        accountObject.accHeadNo = "";
        accountObject.accHeadName = "";
        accountObject.accHeadDesc = "";
        accountObject.remarks = "";
        accountObject.openingBalance = "";
        accountObject.openingDate = "";
        accountObject.selectedAccGrp = {};
        this.setState({
            accountHeadObject: accountObject, validState: validState
        }, () => {
            this.usp_Master_AccountHeadCount();
        });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.getMasterExpenseAccountGroupSelect();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }
    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Account Head Master",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;

                let permissions = response.responseItem.responseContent[0][0];
                this.setPermissions(permissions);
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.08,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idAccountGroup", "sR.No"].includes(key) ? true : false,
                            // width: this.getPinnedWidth(key),
                            // valueGetter: (params) => params.data[key],
                            // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                            //   ? (params) => {
                            //     if (!params.value) return "";
                            //     return moment(params.value).format("DD-MM-YYYY");
                            //   }
                            //   : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        //const priorityColumn = "bankName"; // Replace with the actual column name
                        //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);
                        const desiredOrder = ["idAccountHead", "accountGroup", "accountHead", "accountHeadDesc"];
                        const orderedCols = [
                            ...desiredOrder
                                .map(key => dynamicColDefs.find(col => col.field === key))
                                .filter(Boolean),
                            ...dynamicColDefs.filter(col => !desiredOrder.includes(col.field))
                        ];

                        var colName = orderedCols[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: orderedCols, //updatedColDefs,
                            caption: "Account Head Master",
                            colName: colName
                        }, () => {
                            //this.procSelectAllRecord2GridviewSP(id, "Advance Withdraw");
                            this.usp_Master_AccountHeadCount();
                            this.setPermissions(permissions);
                        });
                    } else {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                            this.getAllDropdownForEmployeeMaster();
                        }
                        this.setPermissions(permissions);
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        this.setState({
            permissions: {
                isAddEdit: permissions.addEdit,
                isDelete: permissions.delete,
                isView: permissions.view,
            }
        });
    };

    getColumnWidth = (key) => {
        const colwidth = {
            "idAccountHead": window.innerWidth * 0.04,
            "accountHead": window.innerWidth * 0.3,
            "accountGroup": window.innerWidth * 0.18,
            "accountHeadDesc": window.innerWidth * 0.11,
            "remarks": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    usp_Master_AccountHeadCount = () => {
        //this.accountMasterServices.getMasterExpenseAccGroupCount(this.state.idCompany).then((response) => {
        //debugger
        //if (response.statusCode == 200 && response.responseItem !== null) {
        let list = this.state.rowData;
        let maxIdPaymentMake = list.length > 0
            ? Math.max(...list.map(item => item.idAccountHead))
            : 0;
        let accheadNo = String(maxIdPaymentMake + 1); //.padStart(3, '0');
        let data = this.state.accountHeadObject;
        data.accHeadNo = accheadNo;
        this.setState({
            accountHeadObject: data
        });
        //}
        //});
    }

    getMasterExpenseAccountGroupSelect = () => {
        this.accountMasterServices.getMasterExpenseAccountGroupSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idAccountGroup,
                    label: x.accountGroup,
                }));
                let object = this.state.accountHeadObject
                object.accGrpList = data;
                this.setState({
                    accountHeadObject: object
                }, () => {
                    // this.getMasterExpenseAccountGroupSelect();
                });
            }
        });
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            //let data = this.state.ledgerDetails;
            let data = this.state.accountHeadObject;

            let requestData = {
                idAccountHead: data.idAccountHead,
                updateStatus: data.updateStatus,
                accountHead: data.accHeadName,
                accountHeadDesc: data.accHeadDesc,
                remarks: data.remarks,
                e_Date: data.e_Date ? data.e_Date : new Date().toISOString(),
                isDeleted: false,
                deletedDate: null,
                idAccountGroup: data.selectedAccGrp.value,
            };
            this.accountMasterServices.submitAccountHeadMaster(requestData).then((response) => {
                //debugger
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData !== null) {
                        //if (this.state.companyObject.updateStatus === 1) {
                        this.SwalServices.Success("Updated sucessfully.");
                        // } else {
                        //   this.SwalServices.Success("Save sucessfully.");
                        // }
                        this.setState({
                            isModalOpen: false,
                        }, () => {
                            this.procSelectAllRecordsSP();
                            this.resetDetailsFields();
                        });
                    } else {
                        this.procSelectAllRecordsSP();
                    }
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    getMasterAccountHeadSelectbyID = (id) => {
        //const isValidAllFields = this.isValidAllFields();
        //if (isValidAllFields) {
        //let data = this.state.ledgerDetails;
        //let data = this.state.accountHeadObject;
        this.accountMasterServices.getMasterAccountHeadSelectbyID(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent[0];
                let data = this.state.accountHeadObject;
                data.idAccountHead = dynamicData.idAccountHead;
                data.updateStatus = 1;
                data.accHeadNo = dynamicData.idAccountHead;
                data.accHeadName = dynamicData.accountHead;
                data.accHeadDesc = dynamicData.accountHeadDesc;
                data.remarks = dynamicData.remarks;
                data.e_Date = dynamicData.e_Date;
                data.isDeleted = dynamicData.isDeleted;
                data.deletedDate = dynamicData.deletedDate;
                data.selectedAccGrp = dynamicData.idAccountGroup > 0 ? data.accGrpList?.find(item => item.value === dynamicData.idAccountGroup) : {};
                this.setState({
                    isModalOpen: true,
                    accountHeadObject: data
                });
            } else {
                this.SwalServices.Error(response.message);
            }
        });
        //}
    }

    render() {
        return (
            <div className='acc-head-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <AccountHeadMasterPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            accountHeadObject={this.state.accountHeadObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Account group</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}